module.exports = __webpack_public_path__ + "static/media/GooglePlayIcon.3bcc5582.svg";